var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"icon",attrs:{"src":require("../assets/hotline.png")},on:{"click":_vm.onCall}})
}
var staticRenderFns = []

export { render, staticRenderFns }